export enum UserRole {
  ADMIN = 'admin',
  SUPPORT = 'support',
  AMC = 'amc-user',
  AMC_ADMIN = 'amc-admin',
}

export interface CreateUserData {
  name: string;
  email: string;
  password: string;
  role: UserRole | string;
  isActive?: boolean;
}

export interface User extends CreateUserData {
  id: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  lastLoggedIn?: string;
}

export interface UpdateUserData {
  name?: string;
  email?: string;
  role?: UserRole | string;
  isActive?: boolean;
  password?: string;
}
